import { Box, Button } from '@factorialco/deprecated-design-system'

import { useFormContext } from 'modules/core/hooks/useForm'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { UpdateData } from 'modules/trainings/pages/MyTrainings/RequestDetail/types'

interface Props {
  updating: boolean
  deleting: boolean
  onDelete: () => void
  setIsUpdating: (value: boolean) => void
  manageEmployee: boolean
}

export const FooterDraft = ({
  updating,
  deleting,
  onDelete,
  setIsUpdating,
  manageEmployee,
}: Props) => {
  const form = useFormContext<UpdateData>()
  const onSendForApproval = () => {
    form.setValues({ ...form.values, status: 'review' })
    form.handleSubmit()
  }
  if (!manageEmployee) return <></>

  return (
    <Box
      width="full"
      maxHeight="s80"
      justifyContent="spaceBetween"
      paddingX="s48"
      paddingY="s24"
      background="white"
      border={{ top: { color: 'grey400', style: 'solid', width: 's1' } }}
      position="sticky"
      style={{ bottom: '0' }}
      flexDirection="row"
    >
      <Button type="secondary" onClick={() => onDelete()} disabled={deleting}>
        {i18n.t('trainings.training_requests.my_requests.detail.delete')}
      </Button>
      <Box flexDirection="row" gap="s8">
        <>
          <Button
            type="secondary"
            onClick={() => {
              track(trackingEvents.training.trainingRequest.saveTrainingRequest, {
                has_updating: form.dirty,
              })
              setIsUpdating(true)
              form.handleSubmit()
            }}
            disabled={updating || !form.isValid}
          >
            {i18n.t('trainings.training_requests.my_requests.detail.save')}
          </Button>
          <Button onClick={() => onSendForApproval()} disabled={updating || !form.isValid}>
            {i18n.t('trainings.training_requests.my_requests.detail.send_for_approval')}
          </Button>
        </>
      </Box>
    </Box>
  )
}
